import { Serializable } from "@/core/api/decorators/serializable_decorator"

export interface ExtensionConfirmationEmailData {
  uid: string
  emailSubject: string
  emailContent: string
  created: string
}

@Serializable
export class ExtensionConfirmationEmailModel {
  uid: string = ""
  emailSubject: string = ""
  emailContent: string = ""
  created: string = ""

  constructor(data: ExtensionConfirmationEmailData | null = null) {
    if (data) {
      this.uid = data.uid ?? ""
      this.emailSubject = data.emailSubject ?? ""
      this.emailContent = data.emailContent ?? ""
      this.created = data.created ?? ""
    }
  }
}
